<template>
  <v-container>
    <v-card shadow>
      <v-card-title>
        จัดการพนักงานคลังสินค้า
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหาพนักงาน"
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          color="indigo white--text"
          class="ml-2"
          elevation="2"
          :disabled="selected.length === 0"
          @click="printCards">
          <v-icon left>
            mdi-card-account-details
          </v-icon>
          พิมพ์บัตร ({{ selected.length }})
        </v-btn>
        <v-btn
          color="primary"
          class="ml-4"
          @click="openAddDialog">
          <v-icon left>
            mdi-plus
          </v-icon> เพิ่มพนักงาน
        </v-btn>
      </v-card-title>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="employees"
        :options.sync="options"
        :items-per-page="options.itemsPerPage"
        :server-items-length="total"
        :loading="loading"
        :footer-props="{'items-per-page-options': [5, 15, 25, 50]}"
        loading-text="กำลังโหลดข้อมูลพนักงาน..."
        show-select
        item-key="id"
        class="elevation-1"
        @update:options="fetchEmployees()"
      >
        <!-- Custom Column: Status -->
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="item.status === 'active' ? 'success' : 'error'"
            dark
            small>
            {{ item.status === 'active' ? 'Active' : 'Inactive' }}
          </v-chip>
        </template>

        <!-- Custom Column: Actions -->
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            color="blue"
            @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="purple"
            @click="printQRCode(item)">
            mdi-qrcode
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="red"
            @click="toggleStatus(item)">
            {{ item.status === 'active' ? 'mdi-account-off' : 'mdi-account-check' }}
          </v-icon>
          <v-icon
            small
            color="red darken-2"
            @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal สำหรับ เพิ่ม/แก้ไข -->
    <v-dialog
      v-model="dialog"
      max-width="600px"
      @click:outside="close()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6">
                  <v-text-field
                    v-model="editedItem.employeeCode"
                    label="รหัสพนักงาน"
                    outlined
                    :rules="[
                      (v) => !!v || 'กรุณากรอกรหัสพนักงาน'
                    ]"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6">
                  <v-text-field
                    v-model="editedItem.email"
                    label="Email"
                    outlined
                    :rules="[
                      (v) => !!v || 'กรุณากรอก Email',
                      (v) => /.+@.+\..+/.test(v) || 'กรุณากรอก Email ให้ถูกต้อง'
                    ]"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6">
                  <v-text-field
                    v-model="editedItem.firstName"
                    label="ชื่อ"
                    outlined
                    :rules="[
                      (v) => !!v || 'กรุณากรอกชื่อ'
                    ]"></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6">
                  <v-text-field
                    v-model="editedItem.lastName"
                    label="นามสกุล"
                    outlined
                    :rules="[
                      (v) => !!v || 'กรุณากรอกนามสกุล'
                    ]"></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6">
                  <v-select
                    v-model="editedItem.department"
                    :items="departments"
                    label="แผนก"
                    outlined
                    :rules="[
                      (v) => !!v || 'กรุณาเลือกแผนก'
                    ]"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="close">
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="saving"
            :disabled="saving"
            @click="save">
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDialog"
      max-width="400px">
      <v-card>
        <v-card-title class="text-h6">
          ยืนยันการเปลี่ยนสถานะ
        </v-card-title>
        <v-card-text>
          คุณต้องการที่จะ <strong>{{ selectedItem.status === 'active' ? 'ปิดการใช้งาน' : 'เปิดการใช้งาน' }}</strong>
          พนักงานคุณ <strong>{{ selectedItem.firstName }} {{ selectedItem.lastName }}</strong> ใช่หรือไม่?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="confirmDialog = false">
            ยกเลิก
          </v-btn>
          <v-btn
            color="success"
            dark
            @click="confirmToggleStatus">
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="qrDialog"
      max-width="400px">
      <v-card class="text-center pa-4">
        <v-card-title class="justify-center">
          QR Code พนักงาน
        </v-card-title>

        <v-card-text>
          <div
            id="print-area"
            class="d-flex flex-column align-center">
            <canvas
              ref="qrCanvas"
              class="qr-canvas-display"></canvas>

            <div class="mt-3 text-h6 black--text">
              {{ selectedItem.employeeCode }}
            </div>
            <div class="text-subtitle-1 grey--text text--darken-2">
              {{ selectedItem.firstName }} {{ selectedItem.lastName }}
            </div>
            <div class="caption grey--text">
              แผนก: {{ selectedItem.department }}
            </div>
          </div>
        </v-card-text>

        <v-divider class="my-4"></v-divider>

        <v-card-actions class="justify-center">
          <v-btn
            color="grey darken-1"
            text
            @click="qrDialog = false">
            ปิด
          </v-btn>
          <v-btn
            color="primary"
            @click="printQRCodeAction">
            <v-icon left>
              mdi-printer
            </v-icon> พิมพ์ QR Code
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      max-width="450px">
      <v-card>
        <v-card-title class="text-h6">
          ยืนยันการลบพนักงาน
        </v-card-title>
        <v-card-text>
          คุณแน่ใจหรือไม่ว่าต้องการลบพนักงาน
          <span class="font-weight-bold red--text">"{{ selectedItem.firstName }} {{ selectedItem.lastName }}"</span>?
          <br>การดำเนินการนี้ไม่สามารถเรียกคืนได้
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="deleteDialog = false">
            ยกเลิก
          </v-btn>
          <v-btn
            color="red darken-1"
            dark
            depressed
            :loading="deleting"
            @click="confirmDelete">
            ยืนยันลบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>

import QRCode from 'qrcode'
import WarehouseWorkTrackingProvider from '@/resources/WarehouseWorkTrackingProvider'
import { mapActions } from 'vuex'

const warehouseWorkTrackingProvider = new WarehouseWorkTrackingProvider()

export default {
  data: () => ({
    search: '',
    selected: [],
    loading: false,
    dialog: false,
    saving: false,
    options: {
      page: 1,
      itemsPerPage: 25,
      sortBy: ['createdAt'],
      sortDesc: [true]
    },
    total: 0,
    headers: [
      { text: 'รหัสพนักงาน', value: 'employeeCode' },
      { text: 'ชื่อ-นามสกุล', value: 'fullName' },
      { text: 'อีเมล', value: 'email' },
      { text: 'แผนก', value: 'department' },
      { text: 'สถานะ', value: 'status' },
      { text: 'จัดการ', value: 'actions', sortable: false }
    ],
    confirmDialog: false,
    deleteDialog: false,
    deleting: false,
    selectedItem: {},
    employees: [],
    qrDialog: false,
    editedIndex: -1,
    editedItem: {
      employeeCode: '',
      firstName: '',
      lastName: '',
      email: '',
      department: '',
      status: 'active',
      store: { name: 'gentlewoman' }
    },
    departments: ['Inbound', 'Outbound', 'Inventory', 'Return', 'Other'],
    stores: ['gentlewoman'],
    rules: {
      required: (v) => !!v || 'กรุณากรอกข้อมูล',
      email: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'รูปแบบ Email ไม่ถูกต้อง'
    }
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มพนักงานใหม่' : 'แก้ไขข้อมูลพนักงาน'
    }
  },
  watch: {
    search () {
      clearTimeout(this.delaySearch)
      this.delaySearch = setTimeout(() => {
        this.fetchEmployees()
      }, 300)
    }
  },
  mounted () {
    this.fetchEmployees()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setErrorPage: 'Components/setErrorPage',
      setModal: 'Components/setModal',
      setSelectedEmployees: 'WarehouseWorkTracker/setSelectedEmployees'
    }),
    async printCards () {
      await this.setSelectedEmployees(this.selected)
      const route = this.$router.resolve({ name: 'WarehouseEmployeePrintCards' })
      window.open(route.href, '_blank')
    },
    async fetchEmployees () {
      this.loading = true
      try {
        const { data: { results, total } } = await warehouseWorkTrackingProvider.getEmployees({
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy[0],
          sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
          search: this.search
        })
        const rawData = results || []
        this.total = total
        this.employees = (Array.isArray(rawData) ? rawData : []).map((item) => ({
          ...item,
          fullName: `${item.firstName} ${item.lastName}`
        }))
      } catch (err) {
        console.error('Failed to fetch employees:', err)
        this.setSnackbar({
          value: true,
          message: 'ไม่สามารถโหลดข้อมูลพนักงานได้',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    openAddDialog () {
      this.editedIndex = -1
      this.editedItem = {
        employeeCode: '',
        firstName: '',
        lastName: '',
        email: '',
        department: '',
        status: 'active',
        store: { name: 'gentlewoman' }
      }
      this.dialog = true
    },
    editItem (item) {
      this.editedIndex = this.employees.indexOf(item)
      this.editedItem = { ...item }
      this.dialog = true
    },
    toggleStatus (item) {
      this.selectedItem = item
      this.confirmDialog = true
    },
    deleteItem (item) {
      this.selectedItem = item
      this.deleteDialog = true
    },
    async confirmDelete () {
      this.deleting = true
      try {
        await warehouseWorkTrackingProvider.deleteEmployee(this.selectedItem.id)
        this.setSnackbar({
          value: true,
          message: 'ลบพนักงานเรียบร้อย',
          type: 'success'
        })
        await this.fetchEmployees()
      } catch (err) {
        console.error('Failed to delete employee:', err)
        this.setSnackbar({
          value: true,
          message: 'ไม่สามารถลบพนักงานได้',
          type: 'error'
        })
      } finally {
        this.deleting = false
        this.deleteDialog = false
      }
    },
    async confirmToggleStatus () {
      try {
        const newStatus = this.selectedItem.status === 'active' ? 'inactive' : 'active'
        await warehouseWorkTrackingProvider.updateEmployeeStatus(this.selectedItem.id, {
          status: newStatus
        })
        const index = this.employees.indexOf(this.selectedItem)
        if (index > -1) {
          this.employees[index].status = newStatus
        }
        this.setSnackbar({
          value: true,
          message: `${newStatus === 'active' ? 'เปิด' : 'ปิด'}การใช้งานเรียบร้อย`,
          type: 'success'
        })
      } catch (err) {
        console.error('Failed to toggle status:', err)
        this.setSnackbar({
          value: true,
          message: 'ไม่สามารถเปลี่ยนสถานะได้',
          type: 'error'
        })
      } finally {
        this.confirmDialog = false
      }
    },
    printQRCode (item) {
      this.selectedItem = item
      this.qrDialog = true
      this.$nextTick(async () => {
        try {
          const canvas = this.$refs.qrCanvas
          await QRCode.toCanvas(canvas, item.qrCodeValue, {
            width: 250,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#ffffff'
            }
          })
        } catch (err) {
          console.error('QR Code generation failed:', err)
        }
      })
    },
    printQRCodeAction () {
      const printWindow = window.open('', '', 'height=600,width=800')
      printWindow.document.write('<html><head><title>Print QR Code</title>')
      printWindow.document.write(`
        <style>
          body { font-family: sans-serif; text-align: center; padding: 20px; }
          canvas, img { max-width: 100%; height: auto; }
          .mt-3 { margin-top: 15px; }
          @media print { .no-print { display: none; } }
        </style>
      `)
      printWindow.document.write('</head><body>')

      const canvas = this.$refs.qrCanvas
      const dataUrl = canvas.toDataURL('image/png')

      printWindow.document.write(`<img src="${ dataUrl }" />`)
      printWindow.document.write(`<div class="mt-3"><strong>${ this.selectedItem.employeeCode }</strong></div>`)
      printWindow.document.write(`<div>${ this.selectedItem.firstName } ${ this.selectedItem.lastName }</div>`)
      printWindow.document.write(`<div>แผนก: ${ this.selectedItem.department }</div>`)

      printWindow.document.write('</body></html>')
      printWindow.document.close()

      setTimeout(() => {
        printWindow.print()
        printWindow.close()
      }, 500)
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.editedIndex = -1
      })
    },
    async save () {
      if (!this.$refs.form.validate()) return
      this.saving = true
      try {
        const payload = {
          employeeCode: this.editedItem.employeeCode,
          firstName: this.editedItem.firstName,
          lastName: this.editedItem.lastName,
          email: this.editedItem.email,
          department: this.editedItem.department,
          store: this.editedItem.store
        }

        if (this.editedIndex > -1) {
          // Update
          await warehouseWorkTrackingProvider.updateEmployee(this.editedItem.id, payload)
          this.setSnackbar({
            value: true,
            message: 'แก้ไขข้อมูลพนักงานเรียบร้อย',
            type: 'success'
          })
        } else {
          // Create
          await warehouseWorkTrackingProvider.createEmployee({
            ...payload,
            status: 'active'
          })

          this.setSnackbar({
            value: true,
            message: 'เพิ่มพนักงานเรียบร้อย',
            type: 'success'
          })
        }
        this.close()
        await this.fetchEmployees()
      } catch (err) {
        console.error('Failed to save employee:', err)
        this.setSnackbar({
          value: true,
          message: err.message || 'ไม่สามารถบันทึกข้อมูลได้',
          type: 'error'
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
